/* eslint-disable react/prop-types, react/no-unstable-nested-components, no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  useContext,
  useEffect,
  useReducer,
  useMemo,
  useState,
} from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  getPaginationRowModel,
  flexRender,
} from '@tanstack/react-table';
import Context from '../utils/context';
import {
  listTiny,
  delTiny,
  listDispatch,
  getOptions,
  delOptions,
  delTinyDispatch,
} from '../redux/tinyActions';
import * as Reducer1 from '../redux/tinyReducer';
import config from '../global/config';
import '../styles/Entries.css';

export const timestamp = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleString(); // formats ISO string to local date/time
};

const UrlCell = ({ value }) => (
  <a href={value} target="_blank" rel="noreferrer noopener" title={value}>
    {value}
  </a>
);

const TinyUrlCell = ({ value, refresh }) => (
  <a
    href={config.fHost() + value}
    target="_blank"
    rel="noreferrer noopener"
    onClick={refresh}
  >
    {config.fHost() + value}
  </a>
);

const ActionPanel = ({ tiny, handleCopy, deleteTiny }) => (
  <div>
    <button
      type="button"
      onClick={() => handleCopy(config.fHost() + tiny)}
    >
      CopyToClipboard
    </button>
    <button
      type="button"
      value={tiny}
      onClick={deleteTiny}
    >
      Delete ?
    </button>
  </div>
);

const Entries = () => {
  const context = useContext(Context);
  const [stateLocal1, dispatchLocal1] = useReducer(
    Reducer1.Reducer1,
    Reducer1.initialState,
  );
  const [sorting, setSorting] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [pageSize, setPageSize] = useState(10);

  const request1 = async () => {
    const res = await fetch(config.apiUri(), getOptions());
    if (res.status === 200) {
      const json = await res.json();
      dispatchLocal1(listDispatch(res, json));
      context.decGlobalValue();
    } else if (res.status === 204) {
      dispatchLocal1(listDispatch(res, []));
    }
  };

  useEffect(() => {
    const tinyUpdateFunc = () => context.addGlobalValue();
    if (context.valueGlobalState) {
      request1();
      tinyUpdateFunc();
    }
  }, [context.valueGlobalState]);

  // Fetch data on mount
  useEffect(() => {
    const urlval = config.healthUri();
    const opts = {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': config.apiHost(),
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    const request = async () => {
      try {
        const res = await fetch(urlval, opts);
        if (res && (res.status === 200 || res.status === 204)) {
          Object.assign(config.principal, { mock: false });
        }
        if (config.mock()) {
          listTiny();
        } else {
          request1();
        }
      } catch {
        request1();
      }
    };
    request();
  }, []);

  const refresh = () => {
    setTimeout(() => {
      request1();
    }, 1000);
  };

  const deleteRequest = async (entry) => {
    const res = await fetch(`${config.apiUri()}/${entry}`, delOptions());
    delTinyDispatch(res);
  };

  const deleteTiny = (e) => {
    context.decGlobalValue();
    const tiny = e.target.value;
    if (config.mock()) {
      delTiny(tiny);
    } else {
      deleteRequest(tiny);
    }
    context.addGlobalValue();
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  const renderActionPanel = (cell) => (
    <div>
      <button
        type="button"
        className="luci-button luci-button--secondary luci-button--small"
        onClick={() => handleCopy(config.fHost() + cell.row.original.tiny)}
      >
        CopyToClipboard
      </button>
      <button
        type="submit"
        className="luci-button luci-button--secondary luci-button--small"
        value={cell.row.original.tiny}
        onClick={deleteTiny}
      >
        Delete ?
      </button>
    </div>
  );

  const columns = useMemo(
    () => [
      {
        header: 'Target Url',
        accessorKey: 'url',
        cell: ({ getValue }) => <UrlCell value={getValue()} />,
      },
      {
        header: 'Tiny Url',
        accessorKey: 'tiny',
        cell: ({ getValue }) => <TinyUrlCell value={getValue()} refresh={refresh} />,
      },
      {
        header: '#Clicks',
        accessorKey: 'counter',
      },
      {
        header: 'Last Visited',
        accessorKey: 'lastAccess',
      },
      {
        header: 'Actions',
        accessorKey: 'actions', // ✅ changed to unique key
        cell: ({ row }) => (
          <ActionPanel
            tiny={row.original.tiny} // still using tiny value
            handleCopy={handleCopy}
            deleteTiny={deleteTiny}
          />
        ),
      },
    ],
    [refresh],
  );

  const entries = useMemo(() => {
    if (!Array.isArray(stateLocal1.data.list)) return [];
    return stateLocal1.data.list.map((row) => ({
      ...row,
      lastAccess: row.last, // ✅ keep original UTC string
    }));
  }, [stateLocal1.data.list]);

  // Create table instance
  const table = useReactTable({
    data: entries,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <div className="table-container">
      <table className="luci-table">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                  style={{ cursor: 'pointer' }}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                  {{
                    asc: ' 🔼 ',
                    desc: ' 🔽 ',
                  }[header.column.getIsSorted()] ?? null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
          {/* Blank rows to fill pageSize */}
          {Array.from({ length: pageSize - table.getRowModel().rows.length }).map((_, i) => {
            const rowKey = `blank-${table.getState().pagination.pageIndex}-${i}`;
            return (
              <tr key={rowKey}>
                {columns.map((col) => (
                  <td key={`${rowKey}-${col.accessorKey || col.header}`} aria-hidden="true">&nbsp;</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="pagination">
        <div className="pagination-inner">
          <button
            type="button"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
            className="page-btn"
          >
            {'< Previous'}
          </button>
          <div className="page-info">
            Page
            <strong>{table.getState().pagination.pageIndex + 1}</strong>
            of
            {' '}
            {table.getPageCount()}
            <span className="rows-info">
              {' '}
              | Rows per page:
              {' '}
              <select
                value={table.getState().pagination.pageSize}
                onChange={(e) => table.setPageSize(Number(e.target.value))}
              >
                {[5, 10, 20, 30, 50].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <button
            type="button"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
            className="page-btn"
          >
            {'Next >'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Entries;
